module.exports = __webpack_public_path__ + "assets/img/TMSP2-4.335e9862.jpg";